import React from "react";
import styles from "./style.module.scss";
import SecondBg from "Utils/Assets/Images/Vector.png";
import Ellipse1 from "Utils/Assets/Images/Ellipse1.png";
import Ellipse2 from "Utils/Assets/Images/Ellipse2.png";
import Ellipse3 from "Utils/Assets/Images/Ellipse3.png";
import Ellipse4 from "Utils/Assets/Images/Ellipse4.png";
import Ellipse5 from "Utils/Assets/Images/Ellipse5.png";

const JoinMovement = () => {
    const cards = [
        {
            text: `"Meetusvr is a game-changer. Shopping in VR while earning real rewards makes every moment worthwhile."`,
            author: "Marvin McKinney",
            image: Ellipse1,
        },
        {
            text: `"The play-to-earn model is brilliant. I connect with people and earn rewards at the same time."`,
            author: "Guy Hawkins",
            image: Ellipse2,
        },
        {
            text: `"Meetusvr takes virtual interaction to a new level. Real rewards, real fun — a perfect mix."`,
            author: "Ralph Edwards",
            image: Ellipse3,
        },
    ];

    const secondRowCards = [
        {
            text: "Every interaction here feels meaningful. Shopping, networking, and earning all in one place.",
            author: "Theresa Webb",
            image: Ellipse2,
        },
        {
            text: "Immersive networking plus VR shopping with rewards — fun and financial empowerment combined.",
            author: "Floyd Miles",
            image: Ellipse4,
        },
        {
            text: "VR shopping with real rewards is revolutionary. The experience itself feels rewarding.",
            author: "Savannah Nguyen",
            image: Ellipse5,
        },
    ];

    const duplicatedCards = [...cards, ...cards, ...cards];
    const duplicatedCards2 = [
        ...secondRowCards,
        ...secondRowCards,
        ...secondRowCards,
    ];

    return (
        <div className={styles.root}>
            <img
                src={SecondBg}
                alt="overlay"
                className={styles.JoinMovementOverlay}
            />

            <div className={styles.content}>
                <h2
                    className={styles.title}
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="false"
                >
                    Join the Movement
                </h2>

                <div className={styles.marqueeContainer}>
                    {/* First Row - Moves Left */}
                    <div className={styles.marqueeRow}>
                        <div className={styles.marqueeTrack}>
                            {duplicatedCards.map((card, index) => (
                                <div
                                    key={`row1-${index}`}
                                    className={styles.card1}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-once="false"
                                >
                                    <p className={styles.card1Text}>
                                        {card.text}
                                    </p>
                                    <div className={styles.card1Author}>
                                        <img
                                            src={card.image}
                                            alt={card.author}
                                        />
                                        <p className={styles.card1AuthorName}>
                                            {card.author}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={`${styles.marqueeRow} ${styles.reverse}`}>
                        <div className={styles.marqueeTrack}>
                            {duplicatedCards2.map((card, index) => (
                                <div
                                    key={`row2-${index}`}
                                    className={styles.card1}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-once="false"
                                >
                                    <p className={styles.card1Text}>
                                        {card.text}
                                    </p>
                                    <div className={styles.card1Author}>
                                        <img
                                            src={card.image}
                                            alt={card.author}
                                        />
                                        <p className={styles.card1AuthorName}>
                                            {card.author}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinMovement;
